module.exports = __webpack_public_path__ + "static/media/profpict.1a9f01a4.jpg";